import React, {Component} from 'react';
import {NavLink, withRouter, Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import {connect} from 'react-redux'

import {
    reqAllUserManage,
} from 'actions/UserManage';

function getStatusRead(data){
    let result;
    data.map(res => {
        if(res.name === 'read') result = res
    })
    return result
}

class SidenavContent extends Component {

    state = {
        data: [],
        param: {}
    }

    async componentDidMount() {
        const {history, dataUser} = this.props;

        if(dataUser.length === 0) {
            await this.props.reqAllUserManage()
        }

        const that = this;
        const pathname = `#/master-menu`;// get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            }
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }

    }

    getDataMenu = (e, data) => {
        this.props.history.push({
            pathname: `/app/${data.path}`,
            state: { detail: data }
        })

        e.preventDefault()

    }

    static getDerivedStateFromProps(nextProps, prevState){
    
        if(nextProps.menu !== prevState.data){

            return {
               data: nextProps.menu
            }
        }

        return null
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const pathname = `#/master-menu`;// get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            }
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            }
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }
    }

    

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (error) {

        }

        return null;
    }

    renderMenu = () => {

        const {data} = this.state
        return data.map(res => {
            if(getStatusRead(res.features).status === true && getStatusRead(res.features).name !== ''){
                return res.children.length === 0 ? (
                    <li key={res.id} className="menu no-arrow">
                        <Link className={`driver-report ${res.module_name}`} to={{ 
                            pathname: res.module_option === 'origin' ? `/app/${res.module_path}`:'/app/attach',
                            search: `?name=${res.module_name}`,
                            state: {foo: 'bar'}
                        }}>
                             <i className={`zmdi ${res.module_icon} zmdi-hc-fw`}/>
                             <span className="nav-text">{res.alias}</span>
                        </Link>
                     </li>
                ):(
                    <li key={res.id} className="menu no-arrow" >
                        <Button href="javascript:void(0)" className={res.module_name}>
                            <i className={`zmdi ${res.module_icon} zmdi-hc-fw`}/>
                            <span className="nav-text">{res.alias} </span>
                        </Button>
                        <ul className="sub-menu">
                            {res.children.map(res2 => {
                               if(getStatusRead(res2.features).status === true && getStatusRead(res2.features).name !== ''){
                                    return res2.children.length === 0 ? (
                                            <li key={res2.id}>
                                                <Link className={`prepend-icon ${res2.module_name}`} to={{ 
                                                    pathname: res2.module_option === 'origin' ? `/app/${res2.module_path}`:'/app/attach',
                                                    search: `?name=${res2.module_name}`,
                                                    state: {foo: 'bar'}
                                                }}>
                                                    <span className="nav-text">
                                                        {res2.alias}
                                                    </span>
                                                </Link>
                                            </li>
                                    ) : (
                                        <li className="menu" key={res2.id}>
                                            <Button className={`prepend-icon ${res2.module_name}`} href="javascript:void(0)">
                                                <span className="nav-text">{res2.alias}</span>
                                            </Button>

                                            <ul className="sub-menu">
                                                {res2.children.map(res3 => {
                                                    if(getStatusRead(res3.features).status === true && getStatusRead(res3.features).name !== ''){
                                                        return (
                                                            <li key={res3.id}>
                                                                <Link className={`prepend-icon ${res3.module_name}`} to={{ 
                                                                    pathname: res3.module_option === 'origin' ? `/app/${res3.module_path}`:'/app/attach',
                                                                    search: `?name=${res3.module_name}`,
                                                                    state: {foo: 'bar'}
                                                                }}>
                                                                    <span className="nav-text">
                                                                        {res3.alias}
                                                                    </span>
                                                                </Link>
                                                            </li>
                                                        )
                                                    }
                                                })}
                                            </ul>
                                        </li>
                                    )
                                }
                            })}

                            
                        </ul>
                    </li>
                )
            } 
        })
    }

    render() {

        return (
            
            <CustomScrollbars className="scrollbar">
                <ul className="nav-menu">

                    {/* <li className="nav-header"><IntlMessages id="sidebar.main"/></li> */}
                    {/* <li className="menu no-arrow">
                        <NavLink to="/app/sample-page">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
                            <span className="nav-text"><IntlMessages id="pages.samplePage"/> </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/master-menu">
                            <i className="zmdi zmdi-widgets zmdi-hc-fw"/>
                            <span className="nav-text">Master Menu</span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/package-menu">
                            <i className="zmdi zmdi-widgets zmdi-hc-fw"/>
                            <span className="nav-text">Package Menu</span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/user-management">
                            <i className="zmdi zmdi-widgets zmdi-hc-fw"/>
                            <span className="nav-text">User Management</span>
                        </NavLink>
                    </li> */}
                    {this.state.data && this.renderMenu()}
                </ul>
            </CustomScrollbars>
        );
    }
}

const mapStateToProps = ({usermanage, auth}) => {
    const { dataUser } = usermanage;
    const { menu } = auth;
    return { dataUser, menu }
};
export default connect(mapStateToProps, {reqAllUserManage})(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js